<div class="sidebar-title-container" (click)="openInformationModal()">
  <ion-label class="sidebar-title">Need help?</ion-label>
</div>
<!-- 
<ion-item class="sidebar-title-container-item" button (click)="openInformationModal()">
  <ion-label class="sidebar-title">Need help?</ion-label>
</ion-item> -->